﻿
// Human API Connect moved to app/shared/services/human-api-connect.service.ts when we went to
// v2.3.  Connect sessions are now started with a backend-minted session token, and the client's
// listeners must only ever be registered once - neither fits a global function.

function yodleeConnect(JwtToken) {    
    window.fastlink.open(
        {
            fastLinkURL: abphc.setting.values['Yodlee.Node'],                
            jwtToken: "Bearer " + JwtToken,
            params: {
                callback: "https://www.google.com/webhp?igu=1",
            },
            forceIframe: true,
            onSuccess: function (data) {
                yodleeComponent.registerToElevateEnv();
                financialComponent.getAllDataYodlee(data.providerAccountId);
                console.log(data);
            },
            onError: function (data) {
                console.log('Connect Error - ' + JSON.stringify(data));
                yodleeComponent.onError(data);
            },
            onExit: function (data) {
                yodleeComponent.close();
            },
            onEvent: function (data) {
                console.log('Connect Event - ' + JSON.stringify(data));
            }
        },
        "container-fastlink"
    );
}

function yodleeRefresh(JwtToken, providerAccountId){
    yodleeComponent.showModal();
    globalJwtToken = JwtToken;

    window.fastlink.open({
        fastLinkURL: abphc.setting.values['Yodlee.Node'],
        jwtToken: "Bearer " + JwtToken,
        forceIframe: true,
        params: { providerAccountId : providerAccountId,
                flow : 'refresh',
                userExperienceFlow: 'Aggregation'
                 }, 
                 onEvent: function (data) {
                    console.log('Refesh Event - ' + JSON.stringify(data));
                    yodleeComponent.showModal();
                },
                onSuccess: function (data)
                {
                    financialComponent.getAllDataYodlee(providerAccountId);
                },
                onExit: function (data)
                {
                    yodleeComponent.close();
                },
                onError: function (data)
                {
                    console.log('Refesh Error - ' + JSON.stringify(data));
                    yodleeComponent.onError(data);
                }
        }, 'container-fastlink');
    }

function yodleeClose() {
    window.fastlink.close();
    yodleeComponent.checkDeregister();
}

var refreshWindow = false;

var globalProviderAccountIds = null;

var globalJwtToken;



var abphc;

var yodleeComponent;

var financialComponent;